export default "__VITE_ASSET__mdzPErRF__"